<template>
	<div class="text">
		<div v-if="$root.loading"></div>
		<h1>Поиск документов</h1>
		<div style="margin: 20px 0 20px 0 !important;">
			<div class="row">
        		<div class="col-sm-4">
        			<div class="form-group">
        				<label>Поиск документов</label>
        				<div class="input-group">
        					<div class="input-group-addon">
        						<i class="fa fa-search"></i>
        					</div>
        					<input type="text" v-model="query" class="form-control" placeholder="Введите ИНН">
        				</div>
        			</div>
        		</div>
        		<div class="col-sm-2">
        			<div class="form-group">
        				<label>&nbsp;</label>
        				<div class="input-group">
        					<div class="row">
        						<div class="col-sm-6">
        							<button class="btn btn-success" @click="search()" :disabled="!query.length">Найти</button>
        						</div>
        					</div>
        				</div>
        			</div>
        		</div>
			</div>
		</div>
		<div>
			<div v-if="invoices.length"> 
				<ul v-for="item in invoices">
					<li><router-link :to="'/documents/'+item.id">{{ item.n_dog }} от {{ item.date }}</router-link></li>
				</ul>
			</div>
			<div v-else>
				<p style="color: grey;">Пока пусто...</p>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				query: '',
				invoices: [],
			}
		},
		methods: {
			search(){
				axios.defaults.headers.get['x-access-token'] = this.$root.token
      			axios.get('https://c.seldon.org/tenma/invoice/search/'+this.query).then((response) => {
      				if(response.data['code'] == 200){
      					this.invoices = response.data['invoices'];
      					if(this.invoices == null){
      						this.invoices = []
      					}
      					this.$root.loading = false
      				}
      			});
			}
		},
		mounted(){
			this.$root.loading = false
		}
	}
</script>

<style>
	.company_label{
		font-size: 16px;
	}

	.text{
		text-align: left;
	}
</style>
